export const getSelectedDataList = (selectedList, DataList, dataField = "") => {
  let data = [];
  // console.log(selectedList,'getSelectedDataList selectedList')
  // console.log(DataList,'getSelectedDataList DataList')
  if (selectedList.length > 0) {
    selectedList.map(function (v) {
      console.log(v)
      const filteredDataList = DataList.filter((l, idx) => l.id === v.id);
      if (filteredDataList.length > 0) {
        if (dataField !== "") {
          data.push(filteredDataList[0][dataField])
        } else {
          data.push(filteredDataList[0])

        }
      }
      return true;
    })
  } else {
    return [];
  }

  return data;
}
function checkType(value) {
  if (Array.isArray(value)) {
    return "Array";
  } else if (typeof value === "object" && value !== null) {
    return "Object";
  } else {
    return "Neither Object nor Array";
  }
}
export function stoneMerge(config, stoneData) {
  let stone_list;
  if (checkType(stoneData) === "Array") {
    stone_list = stoneData
  } else {
    stone_list = []
    stone_list.push(stoneData)
  }
  console.log(stone_list, 'stone_list')
  let list_stone = {};

  stone_list.map((v, k, arr) => {

    // const key = `${config.stone_name&&v.stone_details._id?v.stone_details._id:"no_sc"}_${config.stone_group&&v.stone_group_details._id?v.stone_group_details._id:"no_sg"}_${config.clarity&&v.stone_clarity_details._id?v.stone_clarity_details._id:"no_clar"}_${config.shape&&v.stone_shape_details._id?v.stone_shape_details._id:"no_sh"}`;
    const key = `${config.stone_name && v.stone_details ? v.stone_details._id : ""}_${config.stone_group && v.stone_group_details ? v.stone_group_details._id : ""}_${config.clarity && v.stone_clarity_details ? v.stone_clarity_details._id : ""}_${config.shape && v.stone_shape_details ? v.stone_shape_details._id : ""}_${config.cut && v.stone_cut_details ? v.stone_cut_details._id : ""}_${config.color && v.stone_color_details ? v.stone_color_details._id : ""}_${config.stone_size && v.stone_size_details ? v.stone_size_details._id : ""}`;

    if (!list_stone[key]) {

      list_stone[key] = { ...v };
    } else {
      console.log(list_stone, 'else ees')
      // console.log(merged[key],' merged[key]')
      // console.log(merged[key].Cts,' merged[key].Cts')
      // console.log(stone.Cts,' stone.Cts')
      list_stone[key].Cts = parseFloat(parseFloat(list_stone[key].Cts) + parseFloat(v.Cts)).toFixed(2);
      list_stone[key].Pcs = parseInt(list_stone[key].Pcs) + parseInt(v.Pcs);

    }
    return true;
  })
  const stone_merge_array = Object.values(list_stone).map(stone => ({
    ...stone,

  }));
  return stone_merge_array;

}

// ---- Price code (letters printed in place of digits) -----------------------
// `with_code` is saved on the label profile as { "0".."9": char, repeat: char, "00": char }.

export function hasPriceCode(config = {}) {
  const code = config?.with_code;
  return (
    config?.price_display === "with_code" &&
    !!code &&
    typeof code === "object" &&
    Object.values(code).some((v) => v)
  );
}

// Replaces digits in a formatted price with their code characters.
// Thousands separators are dropped and only the whole-number part is encoded -
// the decimal point and everything after it (cents) are cut off entirely.
// Other non-digits (currency, spaces) in the whole-number part are kept as-is.
// Optional `prefix` / `suffix` characters wrap the encoded result.
//
// The price is read as a sequence of symbols: a single digit, or "00" when
// that code is set. `repeat` means "same as the previous symbol", so it is only
// used when the current symbol is identical to the one just emitted:
//   8=X 00=N repeat=Z :  8000 -> X N 0   (8, 00, 0)   not X N Z (= 8, 00, 00)
//                        80000 -> X N Z  (8, 00, 00)
//                        88 -> X Z       (8, 8)
export function encodePriceWithCode(text, rawCode = {}) {
  const raw = String(text ?? "");
  const decimalIndex = raw.indexOf(".");
  const sample = (decimalIndex === -1 ? raw : raw.slice(0, decimalIndex)).replace(/,/g, "");
  // Codes always print in capitals (a and A are the same code).
  const code = Object.fromEntries(
    Object.entries(rawCode || {}).map(([k, v]) => [k, String(v || "").toUpperCase()])
  );
  let out = "";
  let prevSymbol = null; // "0".."9" or "00"; reset on any non-digit
  for (let i = 0; i < sample.length; i++) {
    const ch = sample[i];
    if (!/\d/.test(ch)) {
      out += ch;
      prevSymbol = null;
      continue;
    }
    let symbol = ch;
    if (ch === "0" && sample[i + 1] === "0" && code["00"]) {
      symbol = "00";
      i += 1;
    }
    if (symbol === prevSymbol && code.repeat) {
      out += code.repeat;
    } else if (symbol === "00") {
      out += code["00"];
    } else {
      out += code[symbol] || symbol;
    }
    prevSymbol = symbol;
  }
  if (!out) return out;
  return (code.prefix || "") + out + (code.suffix || "");
}

// Codes from the client's own script, keyed by row id. Filled by
// attachCustomPriceCodes before printing, so templates still find the code when
// they work on copies of the rows rather than the originals.
const customPriceCodes = new Map();

const rowKey = (row) => String(row?.id ?? row?._id ?? "");

// Retail Price / With Currency: print the whole-number part only (the decimal point and
// digits after it are dropped), wrapped in the profile's prefix/suffix.
// The currency stays outside the wrap (USD #1,250*), and is added after the decimals are
// dropped so a currency like "Rs." keeps its dot.
export function formatNormalPrice(priceText, config = {}, currency = "") {
  const whole = String(priceText ?? "").replace(/\.\d*/, "");
  const { prefix = "", suffix = "" } = config?.normal_encode_pre_suf_fix || {};
  const wrapped = `${prefix}${whole}${suffix}`;
  return currency ? `${currency} ${wrapped}` : wrapped;
}

// Apply the profile's price code to an already formatted price string.
// "with_custom_code" templates get their code from the client's script on the
// server; without one, the raw price prints.
export function applyPriceCode(text, config = {}, row = null) {
  if (config?.price_display === "retail_price") {
    return formatNormalPrice(text, config);
  }
  if (config?.price_display === "with_custom_code") {
    const code = customPriceCodes.get(rowKey(row)) || row?.price_code;
    if (!code) console.warn("custom price code missing for row", rowKey(row), "- printing raw price");
    return code || text;
  }
  if (!hasPriceCode(config)) return text;
  return encodePriceWithCode(text, config.with_code);
}

// Asks the backend to encode prices with the client's own customcode.js.
// Called only for "with_custom_code" templates; every row keeps its raw price
// when the script is missing or fails.
export async function attachCustomPriceCodes(dataList = [], config = {}, _Api) {
  customPriceCodes.clear();   // every print/preview starts clean, so codes never leak between templates
  if (config?.price_display !== "with_custom_code" || !dataList.length || !_Api) return dataList;

  try {
    const items = dataList.map((v) => ({ _id: v?.id || v?._id, price: v?.retailprice_Inc ?? v?.price }));
    const res = await _Api({ items }, "api/v1/price-code/encode");
    if (!res?.available || !Array.isArray(res?.data)) return dataList;

    // The API answers in request order; ids are only a fallback for odd rows.
    const byId = new Map(res.data.map((r) => [String(r._id), r.price_code]));
    dataList.forEach((v, i) => {
      const code = res.data[i]?.price_code ?? byId.get(rowKey(v));
      if (!code) return;
      customPriceCodes.set(rowKey(v), code);   // the source templates read from
      try {
        v.price_code = code;                   // convenience only; rows may be frozen
      } catch (error) { /* read-only row: the map above is enough */ }
    });
  } catch (error) {
    console.error("custom price code failed, printing raw price:", error);
  }
  return dataList;
}

// Templates read everything from profile_setup_info. Make sure with_code and
// price_display are present there even if the API keeps them at top level.
export function getPrintConfig(profileData = {}) {
  const setup = profileData?.profile_setup_info || {};
  const configCheckList = [
    ...(Array.isArray(profileData?.config_check_list) ? profileData.config_check_list : []),
    ...(Array.isArray(setup?.config_check_list) ? setup.config_check_list : []),
    ...(Array.isArray(profileData?.config_check_info?.config_check_list)
      ? profileData.config_check_info.config_check_list
      : []),
  ];
  const isEnabled = (value) => (
    value === true
    || value === 1
    || value === "1"
    || String(value).toLowerCase() === "true"
  );
  const optionChecked = (name) => configCheckList.includes(name);
  return {
    ...setup,
    image: isEnabled(setup.image)
      || isEnabled(profileData?.image)
      || optionChecked("image"),
    text: isEnabled(setup.text)
      || isEnabled(profileData?.text)
      || optionChecked("text"),
    image_config: setup.image_config ?? profileData?.image_config ?? profileData?.config_check_info?.image_config ?? null,
    text_config: setup.text_config ?? profileData?.text_config ?? profileData?.config_check_info?.text_config ?? null,
    price_display: setup.price_display ?? profileData?.price_display,
    text_message: profileData?.config_check_info?.text_message
      ?? profileData?.text_message
      ?? setup?.text_message
      ?? "",
    text_font_size: setup.text_font_size
      || profileData?.text_font_size
      || profileData?.config_check_info?.text_font_size,
    with_code:
      setup.with_code ??
      profileData?.with_code ??
      profileData?.config_check_info?.with_code,
    normal_encode_pre_suf_fix:
      setup.normal_encode_pre_suf_fix ??
      profileData?.normal_encode_pre_suf_fix ??
      profileData?.config_check_info?.normal_encode_pre_suf_fix,
    template3_field_positions:
      setup.template3_field_positions ??
      profileData?.template3_field_positions ??
      profileData?.config_check_info?.template3_field_positions ??
      null,
  };
}

export function getBarcodeByStockId(barcodeArray, stock_id) {
  let barcode = '';

  barcodeArray.map((v, k) => {
    const skustring = v.stock_id
    const search = skustring.search(stock_id);
    if (search >= 0) {
      barcode = v.barcodeImg;
    }
    return true;
  })
  return barcode;

}

export function getQrcodeByStockId(QrArray = [], stock_id = "") {
  let barcode = '';
  QrArray.map((v, k) => {
    const skustring = v.stock_id
    const search = skustring.search(stock_id);

    if (search >= 0) {

      barcode = v.qrcodeImg;
    }
    return true;
  })
  return barcode;

}
// "offline" QR items carry the raw text that was encoded (text_qr) alongside
// the rendered image (qrcodeImg) - needed to size the printed image by how
// much data actually got packed in, not a flat size for every item.
export function getQrTextByStockId(QrArray = [], stock_id = "") {
  let text = '';
  QrArray.map((v, k) => {
    const skustring = v.stock_id
    const search = skustring.search(stock_id);

    if (search >= 0) {
      text = v.text_qr;
    }
    return true;
  })
  return text;

}
export function getQrcodeByProductId(QrArray = [], product_id = "") {
  let barcode = '';
  QrArray.map((v, k) => {
    const skustring = v.product_id
    const search = skustring.search(product_id);

    if (search >= 0) {
      barcode = v.qrcodeImg;
    }
    return true;
  })
  return barcode;

}



export function getBarcodeBySku(barcodeArray, sku) {
  let barcode = '';
  console.log(barcodeArray, "getBarcodeBySku")
  barcodeArray.map((v, k) => {
    const skustring = v.sku
    const search = skustring.search(sku);

    if (search >= 0) {
      barcode = v.barcodeImg;
    }
    return true;
  })
  return barcode;

}
